import VisibleComponent from "../VisibleComponent";
import './index.less'
import Button from "../Button";

const template = `
    <div class="mtg-close-button"></div>
`

let callbackDefault = () => {
    return true
};

class CloseButton extends VisibleComponent {
    constructor(options) {
        super(options);
        this.template = template
        this.init(options)
    }

    init(options) {
        super.init(options);

        new Button({
            type: 'close',
            onClick: e => {
                options && typeof options.onClick === 'function' && options.onClick(e)
            }
        }).appendTo(this.element)

        switch (options && options.position) {
            case "top left":
                this.element.classList.add("mtg-pos-top-left")
                break;
            default:
                // top right
                this.element.classList.add("mtg-pos-top-right")
        }
    }

    showByTimeout({countdown, callbackBeforeShow = callbackDefault, callbackAfterShow = callbackDefault}) {
        let delay = countdown * 1000;
        setTimeout(() => {
            if (callbackBeforeShow()) {
                console.log('====================即将展示关闭按钮', delay, this, this.element.parentNode, this.element.parentNode.parentNode)
                this.appendTo(document.body)
                this.show()
                callbackAfterShow()
            }
        }, delay)
    }

    /**
     * 监听 video timeupdate，视频播放时间满足要求时，显示关闭按钮
     * @param countdown 显示关闭按钮的倒计时（秒）
     * @param videoElem 倒计时要参照的 video 对象
     * @param callbackBeforeShow 关闭按钮展示之前的回调，如果此方法 return false，则会取消展示
     * @param callbackAfterShow
     */
    showByVideoPlayTime({countdown, videoElem, callbackBeforeShow = callbackDefault, callbackAfterShow = callbackDefault}) {
        if (videoElem && typeof videoElem.addEventListener === 'function') {
            videoElem.addEventListener('timeupdate', e => {
                if (videoElem.currentTime >= countdown) {
                    if (callbackBeforeShow()) {
                        this.show()
                        callbackAfterShow()
                    }
                }
            })
        } else {
            console.error('指定的 video 元素为空，请检查：', videoElem)
        }
    }

    // 监听 SDK 计时器事件，倒计时完毕时显示关闭按钮
    showBySDKEventTime({countdown, callbackBeforeShow = callbackDefault, callbackAfterShow = callbackDefault}) {
        document.addEventListener('updateCountdown', (res) => {
            const secondRemain = parseInt(res && res.param && res.param.countdown, 10);
            if (secondRemain <= 0) {
                if (callbackBeforeShow()) {
                    this.show()
                    callbackAfterShow()
                }
            }
        })
    }

}

export default CloseButton